import { ref } from 'vue'
import { createOrdemDeServico } from '../services/requests/OrdemDeServicoRequests'
import { useMessages } from './useMessages'

const { addMessage } = useMessages()

const createStatus = ref('idle') //idle, pending, success, error

const initStatePlanejamento = {
	orsv_nr_intensidade_amostral: null,
	orsv_is_cv: null,
	orsv_is_bitterlich: null,
	orsv_nr_amostra_referencia: null,
	orsv_nr_cv: null,
	orsv_nr_error_target: null,
	orsv_nr_amostra_total: null,
	orsv_nr_buffer: null,
	orsv_tx_metodologia_amostral: 'Sistematica',
}

const initState = {
	id: 'a3d841b4-917e-4b0a-b9a6-0bcae2983350', //'be3d2622-396a-48a8-bba6-801afadc6897',//TODO remover pos teste
	orsv_ds_descricao: 'Instalação Alexis',
	fk_esfl_estrato_florestal: 'feb6a50b-b370-4b1e-a256-73805af8922a', //'190fb0d1-3177-4a7c-9c77-960f9db27726', //TODO remover pos teste
	fk_tpsv_tipo_servico: '',
	orsv_dt_data_inicial: new Date().toLocaleDateString(),
	orsv_dt_prazo_final: new Date(new Date().setDate(new Date().getDate() + 7)).toLocaleDateString(),
	orsv_tx_forma_parcela: '',
	orsv_md_medida_parcela: '',
	orsv_md_geofence: '',
	executoresIds: [],
	tpsv_cd_codigo: '001', //TODO remover pos teste
	tpsv_ds_descricao: '',
	orsv_cd_tipo_servico: '001', //TODO remover pos teste
}

function resetOrdemServico() {
	ordemServico.value = { ...initState, ...initStatePlanejamento }
}

const ordemServico = ref({
	...initState,
	...initStatePlanejamento,
})

export function useOrdemServico() {
	function criarNovaOrdemServico() {
		createStatus.value = 'pending'
		createOrdemDeServico({ ...ordemServico.value, id: crypto.randomUUID() })
			.then(() => {
				createStatus.value = 'success'
				addMessage({
					title: 'Ordem de Serviço criada com sucesso!',
					description: 'A ordem de serviço foi criada com sucesso!',
					type: 'info',
					closeable: true,
				})
			})
			.catch(() => {
				createStatus.value = 'error'
				addMessage({
					title: 'Erro ao criar Ordem de Serviço!',
					description: 'Ocorreu um erro ao criar a ordem de serviço!',
					type: 'error',
					closeable: true,
				})
			})
	}

	return {
		ordemServico,
		criarNovaOrdemServico,
		resetOrdemServico,
		createStatus,
		initStatePlanejamento,
	}
}
